<template lang="pug">
.form-refund.center
  h3 Información del Cliente
  .info-row(v-if="dataOriginal.phones && dataOriginal.phones.length")
    .info-label Teléfonos:
    .info-value {{ dataOriginal.phones.join(', ') }}

  shProductsTable(
    v-if="dataOriginal.products"
    :products="dataOriginal.products"
    :brand="dataOriginal.brand"
    title="Productos del Reembolso"
  )

  h3 Observations
  .observations-container
    .observation(v-for="(observation, index) in dataForm.observations" :key="observation.createdAt" v-if="observation")
      .observation-observation {{ index + 1 }}. {{ observation.observation }}
      div {{ dateTime(observation.createdAt) }}
      shNameUser(:dni="observation.createdBy")

  form(@submit.prevent="")
    .input-container
      textarea.input(v-model="observation" autocomplete="ño" rows="3" required)
      label.label(:class="{ show: observation }") Observación

    shActionButton(:isForm="true" :action="addObservation" text="Agregar Observación" textRunning="Agregando Observación" :normalColor="true")

  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container.arrow
        select.select(v-model="dataForm.type" autocomplete="ño" required)
          option(value="")
          option(v-for="t in types" :value="t.key") {{ t.value }}
        label.label.capitalize(:class="{ show: dataForm.type }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="type" title="¿Por qué quiere el reembolso?")

      template(v-if="refundPayoutKind === 'transfer'")
        .input-container.arrow
          select.select(v-model="dataForm.accountOwnerDniType" autocomplete="ño")
            option(value="")
            option(value="cc") CC - Cédula de Ciudadanía
            option(value="ce") CE - Cédula de Extranjería
            option(value="cel") CEL - Celular
            option(value="de") DE - Documento Extranjero
            option(value="idc") IDC
            option(value="nit") NIT
            option(value="pp") PP - Pasaporte
            option(value="rc") RC - Registro Civil
            option(value="ti") TI - Tarjeta de Identidad
          label.label.capitalize(:class="{ show: dataForm.accountOwnerDniType }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="accountOwnerDniType" title="Tipo de documento del propietario")

        .input-container
          input.input(v-model="dataForm.accountOwnerDni" type="text" autocomplete="ño")
          label.label.capitalize(:class="{ show: dataForm.accountOwnerDni }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="accountOwnerDni" title="DNI Propietario de la cuenta")

        .input-container
          input.input(v-model="dataForm.accountOwnerName" type="text" autocomplete="ño")
          label.label.capitalize(:class="{ show: dataForm.accountOwnerName }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="accountOwnerName" title="Nombre Propietario de la cuenta")

        .input-container
          input.input(v-model="dataForm.account" autocomplete="ño")
          label.label.capitalize(:class="{ show: dataForm.account }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="account" title="Número de cuenta")

        .input-container.arrow
          select.select(v-model="dataForm.accountType" autocomplete="ño")
            option(value="")
            option(value="0") Ahorros
            option(value="1") Corriente
          label.label.capitalize(:class="{ show: dataForm.accountType }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="accountType" title="Tipo de cuenta")

      template(v-else-if="refundPayoutKind === 'llave'")
        .input-container
          input.input(v-model="dataForm.llave" type="text" autocomplete="ño")
          label.label.capitalize(:class="{ show: dataForm.llave }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="llave" title="Llave")

        .input-container
          input.input(v-model="dataForm.llaveOwner" type="text" autocomplete="ño")
          label.label.capitalize(:class="{ show: dataForm.llaveOwner }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="llaveOwner" title="Nombre del titular de la llave")

      .info-row(v-else-if="refundPayoutKind === 'addi'")
        .info-label Método:
        .info-value Addi

      h3 Envío de devolución

      .input-container.arrow
        select.select(v-model="dataForm.conveyorCustomer" autocomplete="ño")
          option(value="")
          option(v-for="conveyor in conveyors" :value="conveyor" :key="conveyor") {{ capitalize(conveyor) }}
        label.label.capitalize(:class="{ show: dataForm.conveyorCustomer }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyorCustomer" title="Transportadora del cliente")

      .input-container
        input.input(v-model="dataForm.tracking" autocomplete="ño")
        label.label.capitalize(:class="{ show: dataForm.tracking }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="tracking" title="Número de guía")

      .input-container
        input.input(v-model.number="dataForm.packageCost" type="number" min="0" max="50000" step="1" autocomplete="ño")
        label.label.capitalize(:class="{ show: dataForm.packageCost || dataForm.packageCost === 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="packageCost" title="Costo del paquete")

      .info-row(v-if="dataOriginal.packReceived")
        .info-label Paquete recibido:
        .info-value
          shNameUser(:dni="dataOriginal.packReceivedBy")
          span  — {{ dateTime(dataOriginal.packReceivedAt) }}

    .divider(v-if="fillData")

    template(v-if="fillData")
      h3 Agregar Comprobante
      div
        input.input-file1(ref="$inputFile" type="file" @change="setFile" accept="image/*" multiple)
        shActionButton(:action="clickFileInput" text="Elegir Comprobantes" textRunning="Elegir Comprobantes" :normalColor="true")

      .images-files
        .image-file(v-for="(file, index) in images" :key="index")
          .image-file-container
            img.image-file-image(:src="createURL(file)")
            .tag-refund {{ imagesStatus[index] || 'Pendiente' }}

      div
        shActionButton(v-if="images.length" :action="uploadPhotos" text="Guardar Comprobantes")

      h3 Comprobantes de Reembolso

      .center
        .images-files
          .image-file(v-for="(receipt, index) in dataForm.receipts" :key="receipt" v-if="receipt")
            .image-file-container
              img.image-file-image(:src="`https://sahet-cdn.b-cdn.net/img/receipts/refunds/${receipt}.jpg`" :alt="`comprobante${index + 1}`")
              shActionButton(:action="deleteImage" :params="[receipt, index]" text="Eliminar" textRunning="Eliminando" :mini="true")

    .form-section
      .list-items.dark.capitalize
        .item-history Status
        .item-history Upadate By
        .item-history Update At

      .list-items(v-if="dataOriginal.declinedBy")
        .item-history.capitalize Declined
        .item-history
          shNameUser(:dni="dataOriginal.declinedBy")
        .item-history {{ dateTime(dataOriginal.declinedAt) }}

      .list-items(v-if="dataOriginal.createdBy")
        .item-history.capitalize Created
        .item-history
          shNameUser(:dni="dataOriginal.createdBy")
        .item-history {{ dateTime(dataOriginal.createdAt) }}

      .list-items(v-if="dataOriginal.approvedBy")
        .item-history.capitalize Approved
        .item-history
          shNameUser(:dni="dataOriginal.approvedBy")
        .item-history {{ dateTime(dataOriginal.approvedAt) }}

      .list-items(v-if="dataOriginal.refundedBy")
        .item-history.capitalize Refunded
        .item-history
          shNameUser(:dni="dataOriginal.refundedBy")
        .item-history {{ dateTime(dataOriginal.refundedAt) }}

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteRefund")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlRefund from '@/graphql/refund'
import gqlImage from '@/graphql/image'
import shDeleteButton from '@/components/elements/DeleteButton'
import shInputList from '@/components/elements/InputList'
import shNameUser from '@/components/elements/NameUser'
import shProductsTable from '@/components/elements/ProductsTable'
import modals from '@my/store/modals'
import auth from '@my/authentication'

export default {
  name: 'FormRefund',

  mixins: [mForm, mFilters, mDB],

  components: { shDeleteButton, shInputList, shNameUser, shProductsTable },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        status: '',
        refund: '',
        order: '',
        receipts: []
      },
      resolver: 'refund',
      key: 'refund',
      gql: gqlRefund,
      gqlImage: gqlImage,
      delete: ['refund', 'order', 'status', 'observations', 'createdAt', 'approvedAt', 'refundedAt', 'declinedAt', 'method', 'products', 'receipts'],
      observation: '',
      images: [],
      imagesStatus: [],
      types: [
        { key: '0', value: 'Derecho al rectracto (aplica hasta 5 días después de que le llegó el producto)' },
        { key: '1', value: 'El pedido llegó tarde' },
        { key: '2', value: 'El pedido no llegó' },
        { key: '3', value: 'No le gustó los productos' },
        { key: '4', value: 'No le quedaron los productos' },
        { key: '5', value: 'Producto fuera de stock' },
        { key: '6', value: 'Envió dinero de más' },
        { key: '7', value: 'Devolución de propina' },
        { key: '8', value: 'El producto llegó dañado o defectuoso' },
        { key: '20', value: 'El cliente hizo el reembolso, está por productos la razón' }
      ]
    }
  },

  created () {
    if (this.fillData) {
      this.dataForm = this.copyObject(this.dataOriginal)
      if (this.dataForm.packageCost == null) this.dataForm.packageCost = 0
      if (!this.dataForm.receipts) this.dataForm.receipts = []
    }
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newRefund()
      } else {
        this.updateRefund()
      }
    },

    newRefund () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateRefund () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteRefund () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    setNameRefundMan () {
      if (!window.event.target.selectedIndex) {
        this.dataForm.nameRefundMan = ''
        return
      }
      this.dataForm.nameRefundMan = this.users[window.event.target.selectedIndex - 1].name
    },
    async addObservation () {
      const mutation = gqlRefund.ADD_OBSERVATION
      const refund = this.dataForm.refund

      const response = await gql.mutate(mutation, { refund, observation: this.observation })

      if (response) {
        modals.showMessage({ message: 'Observación agregada' })
        this.observation = ''
      }
    },

    async uploadPhotos () {
      const newImagesLength = this.images.length
      const oldImagesLength = this.dataForm && this.dataForm.receipts ? this.dataForm.receipts.length : 0

      if ((newImagesLength + oldImagesLength) > 3) {
        modals.showMessage({ message: 'No se puede subir más de 3 imágenes por reembolso', type: 'error' })
        return
      }

      for (let i = 0; i < this.images.length; i++) {
        const image = this.images[i]

        try {
          this.$set(this.imagesStatus, i, 'Subiendo')
          const resizedImage = await this.resizeImage(image, 1500, 1500)
          const nameImage = await this.sendPhoto(resizedImage)
          this.$set(this.imagesStatus, i, 'Subido')
          this.dataForm.receipts.push(nameImage)
        } catch (error) {
          this.$set(this.imagesStatus, i, 'Error')
          console.log(error)
        }
      }
    },
    createURL (file) {
      return URL.createObjectURL(file)
    },
    clickFileInput () {
      this.$refs.$inputFile.click()
    },
    setFile (event) {
      const files = event.target.files || event.dataTransfer.files
      this.images = files
      this.imagesStatus = []
    },
    async sendPhoto (resizedImage) {
      const query = gqlImage.UPLOAD_IMAGE_REFUND
      const variables = { image: null, refund: this.dataForm.refund, token: auth.getToken() }

      const formData = new FormData()
      formData.append('operations', JSON.stringify({ query, variables }))
      formData.append('map', JSON.stringify({ 0: ['variables.image'] }))
      formData.append('0', resizedImage, 'reembolso.jpg')

      const body = formData

      const response = await gql.mutate(query, variables, false, [], body)

      if (!response || !response.data || !response.data.uploadImageRefund) throw new Error('Error desconocido en el servidor')
      return response.data.uploadImageRefund
    },

    resizeImage (file, maxWidth, maxHeight) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        const reader = new FileReader()

        reader.onload = () => {
          const event = window.event

          image.onload = () => {
            let width = image.width
            let height = image.height

            if (width > maxWidth || height > maxHeight) {
              const aspectRatio = width / height

              if (width > height) {
                width = maxWidth
                height = width / aspectRatio
              } else {
                height = maxHeight
                width = height * aspectRatio
              }
            }

            const canvas = document.createElement('canvas')
            canvas.width = width
            canvas.height = height

            const context = canvas.getContext('2d')
            context.drawImage(image, 0, 0, width, height)

            canvas.toBlob((blob) => { resolve(blob) }, file.type, (error) => { reject(error) })
          }

          image.onerror = (error) => { reject(error) }

          image.src = event.target.result
        }

        reader.onerror = (error) => { reject(error) }

        reader.readAsDataURL(file)
      })
    },

    async deleteImage (name, index) {
      const mutation = gqlRefund.DELETE_IMAGE
      const refund = this.dataForm.refund

      const response = await gql.mutate(mutation, { refund, image: name })

      if (response) {
        modals.showMessage({ message: 'Imagen Eliminada' })
        this.dataForm.receipts.splice(index, 1)
      }
    }
  },

  computed: {
    refundPayoutKind () {
      const method = String((this.dataForm.method || (this.dataOriginal && this.dataOriginal.method)) || '').toLowerCase()
      if (method === 'llave') return 'llave'
      if (method === 'addi') return 'addi'
      return 'transfer'
    },
    conveyors () {
      return this.$store.state.variables.conveyors
    },
    users () {
      return this.$store.state.variables.users
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) {
          this.dataForm = this.copyObject(this.dataOriginal)
          if (this.dataForm.packageCost == null) this.dataForm.packageCost = 0
          if (!this.dataForm.receipts) this.dataForm.receipts = []
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-refund
  position relative

.form-refund .button-action:last-child
  margin-top 2em

.observation
  display flex
  justify-content space-between

.observation-observation
  flex-basis 40%
  text-align left

.info-row
  display flex
  justify-content space-between
  padding 0.5em 0
  border-bottom 1px solid rgba(255,255,255,0.1)

.info-label
  font-weight bold
  flex-basis 40%

.info-value
  flex-basis 60%
  text-align right

.input-file1
  display none

.images-files
  display inline-flex
  flex-wrap wrap
  gap 1em
  align-items end
  margin-top 1em
  width 100%
  max-width 50em

.image-file
  text-align center
  margin-bottom 1.5em
  flex-basis 30%

.image-file-container
  min-height 10em
  display flex
  width 100%
  flex-wrap wrap
  gap 1em

.image-file-image
  border-radius 1em
  width 100%
  align-self center

.tag-refund
  background-color #e5e5e6
  align-self flex-end
  padding .3em .5em
  border-radius .5em
</style>



// WEBPACK FOOTER //
// src/components/pages/refund/Form.vue